<template>
	<div class="group-warp">
		<div class="selector">
			<div class="selector-title">商品搜索</div>
			<div class="input-search el-input">
				<input type="text"
				  v-model="keyword"
				  @keyup.enter="getList(true)"
				  autocomplete="off" maxlength="20" placeholder="输入商品名称" class="el-input__inner">
			</div>
			
			<div class="selector-title">商品分类</div>
			<el-select v-model="goods_cateid" clearable placeholder="不限">
			<el-option
			  v-for="item in goods_category"
			  :key="item.id"
			  :label="item.name"
			  :value="item.id">
			</el-option>
			</el-select>
				
				
			<el-button class="btn btn-search" type="primary" @click="getList(true)">查询</el-button>
			<el-button class="btn btn-add" type="warning" @click="add()">+添加商品信息</el-button>
		</div>
		
		<!-- 列表 -->
		<div  class="list-box">
			<el-table v-loading="loading" :data="list" :row-class-name="tableRowClassName">
				
				<el-table-column label="商品图" align="center" width="120">
					<template slot-scope="scope">
						<img :src='scope.row.cover' class="dcover" />
					</template>
				</el-table-column>
				
				<el-table-column prop="name" label="商品名称" width="250" align="left">
					<template slot-scope="scope">
					<div style="font-size: 14px;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;">
						{{scope.row.name}}
					</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="category" label="商品分类" width="80" align="center">
					<template slot-scope="scope">
						<template v-if="scope.row.category != ''">
							{{scope.row.category}}
						</template>
						<template v-else>
							-
						</template>
					</template>
				</el-table-column>
				
				<el-table-column prop="retail_price" label="零售价" width="80" align="center">
					<template slot-scope="scope">
						<div>
						<span>￥</span>{{scope.row.retail_price}}
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="tv_price" label="直播价" width="80" align="center">
					<template slot-scope="scope">
						<div class="tv_price">
							<template v-if="scope.row.tv_price > 0">
								<span>￥</span>{{scope.row.tv_price}}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="scene" label="商品场景" width="200" align="center">
					<template slot-scope="scope">
					<el-tooltip placement="top" :open-delay="700" effect="dark" v-if="scope.row.scene != ''">
						<template slot="content">
							<p style="max-width: 250px;">{{scope.row.scene}}</p>
						</template>
						<div style="font-size: 14px;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;cursor: pointer;">
							{{scope.row.scene}}
						</div>
					</el-tooltip>
					
					<template v-else>
						-
					</template>
					</template>
				</el-table-column>
				
				<el-table-column prop="media_count" label="商品素材" width="100" align="center"></el-table-column>
				
				<el-table-column prop="use_num" label="引用次数" width="100" align="center"></el-table-column>
				
				<el-table-column prop="sort" width="200" label="排序" align="center">
					<template slot="header" slot-scope="scope">
						排序
						<el-tooltip content="数值越小越靠前" placement="top-end" effect="dark">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</template>
					<template slot-scope="scope">
						<el-input class="sort" v-model="scope.row.sort" @input="inputSort($event,scope.row.index)" @change="changeSort($event,scope.row.index)" maxlength="9" :min="0" :max="999999999" label="排序"></el-input>
					</template>
				</el-table-column>
				
				<el-table-column prop="save" label="操作" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button class="op-btn" type="text" size="medium" @click="add(scope.row.index)">编辑</el-button>
						<el-button class="op-btn" type="text" size="medium" @click="del(scope.row.index)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			
		</div>
			
		<!-- 分页器 -->
		<div class="block" style="padding-top: 40px;background: #ffffff;" v-if="list.length > 0">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
			</el-pagination>
		</div>
		
	</div>
	
	
</template>

<script>
	import {
		getGoodsIndexList,
	} from '@/api/depot_goods_index.js';
	import {
		getList,
		changeSort,
		delGoods
	} from '@/api/depot_goods.js';
	
	export default {
		data() {
			return {
				goods_cateid: "",
				goods_category: [],
				
				loading: false,
				list: [],
				keyword: '',
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				oper_index: 0, // 当前操作的行下标
			}
		},
		components: {
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			let keyword = localStorage.getItem('keyword');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				this.keyword = keyword
				localStorage.setItem('keypage', '')
				localStorage.setItem('keyword', '')
			}
			this.getGoodsIndexList();
			this.getList();
		},
		methods: {
			getGoodsIndexList(){
				getGoodsIndexList({
					type: 1
				}).then(res => {
					if (res.code == 0) {
						this.goods_category = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getList(refresh=false) {
				if (refresh) {
					this.currentPage = 0;
				}
				var currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				
				this.loading = true;
				
				getList({
					start: currentPage * this.pageSize,
					limit: this.pageSize,
					keyword: this.keyword,
					category_id: this.goods_cateid,
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.allcount;
						this.list = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			inputKeyword(value) {
				this.keyword = value.trim()
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			// 排序输入事件
			inputSort(value = 0,index = 0){
				value = value.replace(/[^\d]/g, "");
				this.list[index].sort = Number(value);
			},
			// 调整排序
			changeSort(value = 0,index = 0){
				let id = this.list[index].id;
				changeSort({
					id: id,
					sort: value
				}).then(res => {
					if (res.code == 0) {
						// this.getList();
						this.$message.success('修改成功');
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 增加表格内的索引
			tableRowClassName({row, rowIndex}) {
				//把每一行的索引放进row
				row.index = rowIndex;
			},
			// 删除
			del(index = 0){
				this.$confirm('确认删除该商品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delGoods({
						id: this.list[index].id
					}).then(res => {
						if (res.code == 0) {
							this.$message.success(res.message);
							
							// -- 此段代码为了保证当前页面数据都全部删除时，可以获取前一个页面内容
							this.list.splice(index,1);
							if(this.list.length == 0){
								this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
							}
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
				
				});
			},
			// 添加&编辑
			add(index = -1){
				this.oper_index = index;
				
				localStorage.setItem('keypage', this.currentPage)
				localStorage.setItem('keyword', this.keyword)
				if(index > -1){
					this.$router.push({
						path: '/separation/information-add',
						query: {id: this.list[index].id}
					});
				}else{
					this.$router.push({
						path: '/separation/information-add',
						query: {}
					});
				}
			},
			
		}
	}
	
	function one1(){
		var p = new Promise(function(resolve,reject){
			setTimeout(function(){
				 var num = 1;// Math.ceil(Math.random()*10); //生成1-10的随机数
				if(num<=5){
					resolve(num);
				}
				else{
					reject('数字太大了');
				}
			},2000)
		})
		
		return p;
	}
	function one2(){
		var p = new Promise(function(resolve,reject){
			setTimeout(function(){
				console.log("第二个异步任务，执行完成")
				resolve("data2")
			},2000)
		})
		
		return p;
	}
	function one3(){
		var p = new Promise(function(resolve,reject){
			setTimeout(function(){
				console.log("第三个异步任务，执行完成")
				resolve("data3")
			},2000)
		})
		
		return p;
	}
</script>

<style scoped>
	.group-warp{
		background: #FFFFFF;
		min-height: 500px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		padding: 20px 10px;
		border-radius: 5px;
	}
	
	.selector {
		padding: 0 15px 15px 0;
		height: 40px;
		display: flex;
		align-items: center;
	}
	.selector-title{
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		color: #333333;
		margin-right: 10px;
	}
	.input-search {
		width: 400px;
		margin-right: 30px;
	}
	.btn-search{
		width: 110px;
		margin-left: 20px;
	}
	.btn-add{
		background: #FF8700;
	}
	
	.list-box{
		min-height: 400px;
	}
	.list-box .sort{
		width: 110px;
	}
	.list-box .tv_price{
		color: #F56C6C;
	}
	.list-box .dcover{
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 4px;
	}
</style>